import axios from 'axios';

const api = axios.create({
    // baseURL: 'http://localhost:8000/api',
    baseURL: 'https://webserver.becallcolombia.com/digicel-backend/public/api',
    mode: 'cors',
});

const apiEmail = axios.create({
    baseURL: 'https://webserver.becallcolombia.com/enviocorreo/public/api',
    mode: 'cors',
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('expires_at');
            localStorage.removeItem('login');
            localStorage.removeItem('infoUser');
            window.location.href = '/Login';
        }
        return Promise.reject(error);
    }
);

function getData(url) {
    return api.get(`/${url}`)
    .then(response  => {
        return response;
    }).catch(error => {
        return {'catch': true, 'error': error.message};
    })
}

function postData(url, data) {
    return api.post(`/${url}`, data)
    .then(response => {
        return response.data;
    }).catch(error => {
        return {'catch': true, 'error': error.message, 'data': error.config.data, 'error2': JSON.stringify(error)};
    })
}

function postEmail(url, data) {
    return apiEmail.post(`/${url}`, data)
    .then(response => {
        return response.data;
    }).catch(error => {
        return {'catch': true, 'error': error.message, 'data': error.config.data};
    })
}

function updateData(url, data) {
    return api.put(`/${url}`, data)
    .then(response => {
        return response.data;
    }).catch(error => {
        return {'catch': true, 'error': error.message, 'data': error.config.data};
    })
}
    
export {getData, postData, postEmail, updateData}